import { Paper } from "@material-ui/core";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { baseUrl } from "../../../services/config";
import { Spinner, Table } from "react-bootstrap";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import "./checkList.css";
import { useRef } from "react";
import ExportIt from "./ExportIt";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";

const CheckList = () => {
  useEffect(() => {
    getSettingData();
    // getAllCampus();
    sessions();
  }, []);

  const [selectedcampus, setselectedcampus] = useState("");
  const [classes, setClasses] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [selectedClass, setSelectedClass] = useState("");
  const [sectionData, setSectionData] = useState([]);
  const [selectedSection, setselectedsection] = useState("");
  const [sessionData, setSessionData] = useState([]);
  const [reportData, setReportData] = useState({});
  const [yearId, setYearId] = useState("");
  const [loading, setloading] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [fullSession, setFullSession] = useState({});
  const [educationType, setEducationType] = useState(1);
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const pageStyle = `
    @page {
  margin-left: 1.5in;
      size: legal landscape !important;
  }
  `;
  const [isVisible, setIsVisible] = useState(false);
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const [includeFee, setIncludeFee] = useState(false);
  const [isLeadingClass, setIsLeadingClass] = useState(false);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setFullSession(session);
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = async (campusId) => {
    setCampusCourseData([]);
    setCourseClassData([]);
    setClassSectionData([]);

    if (campusId == "") {
      return alert.error("Please Select Campus");
    }
    await fetch(`${baseUrl}/campus-all-courses/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseId("");
          setClassId("");
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = async (courseId) => {
    setCourseClassData([]);
    setClassSectionData([]);

    if (courseId == "") {
      return alert.error("Please Select Course");
    }
    await fetch(`${baseUrl}/course-all-classes/${courseId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassId("");
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleShow = () => {
    if (campusId == "") {
      alert.error("Please Select The Campus");
      return;
    }
    let data = {
      campus_id: campusId,
      course_id: courseId,
      class_id: classId,
      section_id: sectionId,
      year_id: yearId,
      include_fee: includeFee ? 0 : 1,
      is_leading_class: isLeadingClass ? 1 : 0,
    };
    setloading(true);

    fetch(`${baseUrl}/student-check-list`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          setloading(false);
          if (data.metadata) {
            if (data.metadata.success) {
              let sum = 0;
              data.payload.campus_data.map((item) => {
                item.classes.map((subitem) => {
                  subitem.sections.map((subsubitem) => {
                    subsubitem.students.map((student) => {
                      sum += parseInt(student.monthly_fees);
                    });
                  });
                });
              });
              setGrandTotal(sum);
              setReportData(data.payload);
            }
          }
        })
      )

      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };
  //for print
  const handleBeforePrint = React.useCallback(() => {
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
  }, []);
 let num = 0;
 let num1 = 0;
  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mt-2">
          <div className="col-md-3">
            <label>
              <b>Select Session</b> <span style={{ color: "red" }}>*</span>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => {
                  const selectedObject = sessionData.find(
                    (option) => option.id == e.target.value
                  );
                  setFullSession(selectedObject);
                  setYearId(e.target.value);
                }}
              >
                <option value="">Select Session</option>
                {sessionData &&
                  sessionData.map((item, index) => (
                    <option key={index} value={item.id}>{item.year}</option>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Campus </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => onCampusChange(e.target.value)}
              className="form-select"
              style={{ backgroundColor: "white", height: 40 }}
              value={campusId}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>
              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Course </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="course_id"
              value={courseId}
              onChange={(e) => onCourseChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Course</option>
              {campusCourseData.map((item, index) => (
                <option key={index} value={item.course?.id}>
                  {item.course?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="class_id"
              value={classId}
              onChange={(e) => onClassChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              {courseClassData.map((item, index) => (
                <option key={index} value={item.class?.id}>
                  {item.class?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-3">
            <label>
              <b>Select Section </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="section_id"
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              style={{ backgroundColor: "white" }}
              aria-label="Default select example"
            >
              <option value="">Select Section</option>
              {classSectionData.map((item, index) => (
                <option key={index} value={item.section?.id}>
                  {item.section?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6 mt-8 d-flex">
            <div style={{ height: 40 }} className="col-md-4 mt-4">
              <input type="checkbox" style={{ display: "none" }} />
              <label className="checkbox checkbox-single mt-4">
                <input
                  type="checkbox"
                  onChange={(e) => setIncludeFee(e.target.checked)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Do Not Show Fee
              </label>
            </div>
            
            <div style={{ height: 40 }} className="col-md-6 mt-4">
              <input type="checkbox" style={{ display: "none" }} />
              <label className="checkbox checkbox-single mt-4">
                <input
                  type="checkbox"
                  onChange={(e) => setIsLeadingClass(e.target.checked)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Show Leading Class Students
              </label>
            </div>

            <button className="btn btn-primary mt-4" onClick={handleShow}>
              Show
            </button>

            {reportData.campus && (
              <>
                <ExportIt reportData={reportData} isLeadingClass = {isLeadingClass} />
                <ReactToPrint
                  documentTitle={`Check List Report`}
                  pageStyle={pageStyle}
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      // onClick={() => console.log("dfsdfsdfd")}
                      disabled={printloading ? true : false}
                      className="btn btn-success button_blue button_blue mx-2 mt-4"
                    >
                      {printloading ? <span>Printing..</span> : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />
              </>
            )}
          </div>
        </div>

        {loading ? (
          <div
            className="row justify-content-center"
          >
            <Spinner className="text-center" variant="info" animation="border" />
          </div>
        ) : (
          <div id="tableboot">
            <div className="row p-3 mt-5">
              <img
                // className='col-md-2'
                style={{ height: 110, width: 110 }}
                src={icon}
              />

              <div className="col-md-6">
                <h1>{unitName}</h1>
                <h6>
                  LIST OF STUDENT FOR THE ACADEMIC SESSION {fullSession.year}{" "}
                  {""}
                </h6>
              </div>
            </div>
            <ColoredLine color={"#FF0000"} />

            {reportData.campus && (
              <Table responsive>
                <thead>
                  <tr id="tbl">
                    <th>Sr.</th>
                    <th>{isLeadingClass ? "Reg-Id" : "Adm-Id"}</th>
                    <th>Student Name</th>
                    <th>Father Name</th>
                    <th>Mobile No</th>
                    <th>Phone No</th>
                    <th>CNIC</th>
                    <th>Father's CNIC</th>
                    <th>DOB</th>
                    <th>Gender</th>
                    <th>Monthly Fee</th>
                    <th>Address</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td></td>
                    <td
                      colSpan={11}
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                      className="text-start"
                    >
                      {reportData.campus}
                    </td>
                  </tr>
                  {reportData.campus_data.map((item, index) => (
                    item.classes.map((subitem, index) => (
                      subitem.sections.map((subsubitem, index) => (
                        <React.Fragment key={index}>
                          <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th colSpan={3} style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "15px",
                          }}
                            className="text-center">Course: &nbsp; {item?.course?.name}
                          </th>
                          <th
                          colSpan={3}
                            style={{
                              color: "black",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                            className="text-center"
                          >
                            Class: &nbsp; {subitem?.class}
                          </th>
                          <th
                          colSpan={3}
                            style={{
                              color: "black",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                            className="text-start"
                          >
                            Section: &nbsp; {subsubitem?.section}
                          </th>
                          </tr>
                          {subsubitem.students.map((student, i) => (
                            <tr id="tbl" key={i}>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {(num += 1)}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {isLeadingClass ? student.registration_id : student.admission_id}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.name}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.father_name}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.mobile_no}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.phone}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.cnic_no}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.father_cnic}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.dob}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.gender}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student?.monthly_fees != 0
                                  ? student?.monthly_fees
                                  : null}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.address}
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      )))
                    )))}
                </tbody>
              </Table>
            )}
            {grandTotal > 0 && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "end",
                  columnGap: "20px",
                  paddingRight: "200px",
                }}
              >
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Grand Total of Monthly Fee:-
                </p>
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  {grandTotal}
                </p>
              </div>
            )}
          </div>
        )}

        <div
          ref={componentRef}
          id="printSection"
          className="customTablePrint marginLeftTolegal"
        >
          <div id="tableboot" style={{ padding: "0px 10px" }}>
            <div className="p-3" style={{ display: "flex" }}>
              <img
                style={{ height: 100, width: 100 }}
                src={icon}
              />

              <div className="col-md-6" style={{ paddingTop: "10px" }}>
                <h1>{unitName}</h1>
                <h6>
                  LIST OF STUDENT FOR THE ACADEMIC SESSION {fullSession.year}{" "}
                  {""}
                </h6>
              </div>
            </div>
            <ColoredLine color={"#FF0000"} />

            {reportData.campus && (
              <table style={{ width: "100%" }}>
                <thead>
                  <tr id="tbl" style={{ fontSize: "13px", borderBottom: "1px solid black" }}>
                    <td style={{ color: "black", textAlign: "start" }}>
                      <b>Sr.</b>
                    </td>
                    <td style={{ color: "black" }}>
                      <b>{isLeadingClass ? "Reg-Id" : "Adm-Id"}</b>
                    </td>
                    <td style={{ textAlign: "start", color: "black" }}>
                      <b>
                        Student Name
                      </b>
                    </td>
                    <td style={{ textAlign: "start", color: "black" }}>
                      <b>
                        Father Name
                      </b>
                    </td>
                    <td style={{ color: "black", textAlign: "start" }}>
                      <b>
                        Mobile No
                      </b>
                    </td>
                    <td style={{ color: "black", textAlign: "start" }}>
                      <b>
                        Phone No
                      </b>
                    </td>
                    <td style={{ color: "black", textAlign: "start" }}>
                      <b>
                        CNIC
                      </b>
                    </td>
                    <td style={{ color: "black", textAlign: "start" }}>
                      <b>
                        Father's CNIC
                      </b>
                    </td>
                    <td style={{ color: "black" }}>
                      <b>DOB</b>
                    </td>
                    <td style={{ color: "black" }}>
                      <b>Gender</b>
                    </td>
                    <td style={{ color: "black" }}>
                      <b>Fee</b>
                    </td>
                    <td style={{ color: "black" }}>
                      <b>Address</b>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr 
                 style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "15px",
                  borderBottom: "1px solid black",
                }}
                  >
                    <td></td>
                    <td
                    colSpan={11}
                      className="text-start"
                    >
                      {reportData.campus}
                    </td>
                  </tr>
                  {reportData.campus_data.map((item, index) => (
                    item.classes.map((subitem, index) => (
                      subitem.sections.map((subsubitem, index) => (
                        <React.Fragment key={index}>
                        <tr style={{borderBottom: "1px solid black",}}>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th colSpan={3} style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "15px",
                          }}
                            className="text-center">Course: &nbsp; {item?.course?.name}
                          </th>
                          <th
                          colSpan={3}
                            style={{
                              color: "black",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                            className="text-center"
                          >
                            Class: &nbsp; {subitem?.class}
                          </th>
                          <th
                          colSpan={3}
                            style={{
                              color: "black",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                            className="text-start"
                          >
                            Section: &nbsp; {subsubitem?.section}
                          </th>
                          </tr>
                        {subsubitem.students.map((student, i) => (
                          <tr key={i}
                            id="tbl managingtrHeight"
                            style={{
                              borderBottom: "1px solid black",
                              fontSize: "13px",
                            }}
                          >
                            <td
                              style={{ color: "black", minWidth: "50px" }}
                              className="text_align_start checklistlinehighter"
                            >
                               {(num1 += 1)}
                            </td>
                            <td
                              style={{ color: "black", width: "70px" }}
                              className="text_align_start checklistlinehighter"
                            >
                              {isLeadingClass ? student.registration_id : student.admission_id}
                            </td>
                            <td
                              style={{ color: "black", width: "250px" }}
                              className="text_align_start checklistlinehighter"
                            >
                              {student.name.length > 25
                                ? student.name.slice(0, 25)
                                : student.name}
                            </td>
                            <td
                              style={{ color: "black", width: "250px" }}
                              className="text_align_start checklistlinehighter"
                            >
                              {student.father_name.length > 25
                                ? student.father_name.slice(0, 25)
                                : student.father_name}
                            </td>
                            <td
                              style={{ color: "black", paddingRight: "10px" }}
                              className="text_align_start checklistlinehighter"
                            >
                              {student.mobile_no}
                            </td>
                            <td
                              style={{ color: "black", paddingRight: "10px" }}
                              className="text_align_start checklistlinehighter"
                            >
                              {student.phone}
                            </td>
                            <td
                              style={{ color: "black", width: "150px" }}
                              className="text_align_start checklistlinehighter"
                            >
                              {student.cnic_no}
                            </td>
                            <td
                              style={{ color: "black", width: "150px" }}
                              className="text_align_start checklistlinehighter"
                            >
                              {student.father_cnic}
                            </td>
                            <td
                              style={{ color: "black" }}
                              className="text_align_start checklistlinehighter checkDobheight"
                            >
                              {student.dob}
                            </td>
                            <td
                              style={{ color: "black" }}
                              className="text_align_start checklistlinehighter"
                            >
                              {student.gender}
                            </td>
                            <td
                              style={{ color: "black" }}
                              className="text_align_start checklistlinehighter"
                            >
                              {student?.monthly_fees != 0
                                ? student?.monthly_fees
                                : null}
                            </td>
                            <td
                              style={{ color: "black" }}
                              className="text_align_start checkAddress"
                            >
                              {student.address}
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))
                    )))
                  )}
                </tbody>
              </table>
            )}
            {grandTotal > 0 && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "end",
                  columnGap: "20px",
                  paddingRight: "200px",
                  paddingTop: "20px",
                }}
              >
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Grand Total of Monthly Fee:-
                </p>
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  {grandTotal}
                </p>
              </div>
            )}
          </div>
        </div>
      </Paper>
    </>
  );
};

export default CheckList;
const ColoredLine = ({ color }) => (
  <hr
    style={{
      color: color,
      backgroundColor: color,
      height: 5,
    }}
  />
);
